import { useContext } from 'react';
import EditorContext from '../providers/EditorProvider';

const useEditor = () => useContext(EditorContext);

export default useEditor;
